import type { CSSProperties } from 'vue';

// Inline styles applied to the light-DOM wrapper we project into the
// `gutter-utility-slot`. These mirror the React adapter's styles so the gutter
// utility overlays the gutter column identically in both frameworks.
export const GutterUtilitySlotStyles: CSSProperties = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  textAlign: 'center',
  whiteSpace: 'normal',
  touchAction: 'none',
};

// Merge-conflict action wrappers must not introduce their own box; `contents`
// lets the projected content participate in the diff layout directly.
export const MergeConflictSlotStyles: CSSProperties = {
  display: 'contents',
};

// Placeholder render callback handed to the imperative core. Its *presence*
// (not its return value) flips a header/gutter/merge-conflict slot into
// custom-slot mode; Vue then projects the real content through a named
// shadow-DOM slot, so this intentionally renders nothing.
export function noopRender(): undefined {
  return undefined;
}
